import Link from "next/link";

export const ListingCheckoutTermsAndCondition = () => {
  return (
    <>
      By checking this box you have read and agree to Attend’s{" "}
      <Link
        className="global-link"
        target="_blank"
        href="https://www.attend.tech/terms-of-use"
      >
        Terms of Use
      </Link>
      ,{" "}
      <Link
        className="global-link"
        target="_blank"
        href="https://www.attend.tech/privacy-policy"
      >
        Privacy Policy
      </Link>{" "}
      and{" "}
      <Link
        className="global-link"
        target="_blank"
        href="http://attend.tech/marketplace-purchase-policy"
      >
        Purchase Policy
      </Link>
      .
    </>
  );
};

export const CreateListingTermsAndCondition = () => {
  return (
    <>
      By clicking “Create Listing”, you have read and agree to Attend’s{" "}
      <Link
        className="global-link"
        target="_blank"
        href="https://www.attend.tech/terms-of-use"
      >
        Terms of Use
      </Link>
      ,{" "}
      <Link
        className="global-link"
        target="_blank"
        href="https://www.attend.tech/privacy-policy"
      >
        Privacy Policy
      </Link>{" "}
      and{" "}
      <Link
        className="global-link"
        target="_blank"
        href="http://attend.tech/marketplace-purchase-policy"
      >
        Purchase Policy
      </Link>
      .
    </>
  );
};
